import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const analyticsPlugin = createPlugin({
  id: 'analytics',
  routes: {
    root: rootRouteRef,
  },
});

export const AnalyticsDashboardPage = analyticsPlugin.provide(
  createRoutableExtension({
    name: 'AnalyticsDashboardPage',
    mountPoint: rootRouteRef,
    component: () =>
      import('./components/AnalyticsDashboard').then(m => m.AnalyticsDashboard),
  }),
);
